// Helper function to check for undefined environment variables
const getEnvVar = (name) => {
  const value = process.env[name];
  if (!value) {
    console.warn(`Environment variable ${name} is not defined`);
  }
  return value || '';
};

const awsConfig = {
  "aws_project_region": getEnvVar('REACT_APP_AWS_REGION'),

  "aws_cognito_region": getEnvVar('REACT_APP_AWS_REGION'),
  "aws_user_pools_id": getEnvVar('REACT_APP_USER_POOL_ID'),
  "aws_user_pools_web_client_id": getEnvVar('REACT_APP_USER_POOL_CLIENT_ID'),
  "oauth": {
    "domain": getEnvVar('REACT_APP_OAUTH_DOMAIN'),
    "redirectSignIn": getEnvVar('REACT_APP_OAUTH_REDIRECT_SIGN_IN'),
    "redirectSignOut": getEnvVar('REACT_APP_OAUTH_REDIRECT_SIGN_OUT'),
    "responseType": "code"
  },
  "aws_cognito_username_attributes": [
    "EMAIL"
  ],
  "aws_cognito_social_providers": [],
  "aws_cognito_signup_attributes": [
    "EMAIL"
  ],
  "aws_cognito_mfa_configuration": "OFF",
  "aws_cognito_mfa_types": [
    "SMS"
  ],
  "aws_cognito_password_protection_settings": {
    "passwordPolicyMinLength": 8,
    "passwordPolicyCharacters": []
  },
  "aws_cognito_verification_mechanisms": [
    "EMAIL"
  ],
  // API configuration section
  "aws_cloud_logic_custom": [
    {
      "name": "ai_analysis",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_AI_ANALYSIS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },

    {
      "name": "cv_analysis_results",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_CV_ANALYSIS_RESULTS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },

      {
      "name": "delete_cv_analysis",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_DELETE_CV_ANALYSIS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },

     {
      "name": "get_internship_data",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_GET_INTERNSHIP_DATA'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },

     {
      "name": "job_details",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_JOB_DETAILS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },
     {
      "name": "delete_saved_job",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_DELETE_SAVED_JOB'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },
     {
      "name": "save_job",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_SAVE_JOB'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },
    {
      "name": "score_cv_job",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_SCORE_CV_JOB'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },
    {
      "name": "get_saved_job",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_GET_SAVED_JOBS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },
    {
      "name": "user_stats",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_USER_STATS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    },
    {
      "name": "get_saved_job_details",
      "endpoint": getEnvVar('REACT_APP_API_ENDPOINT_GET_SAVED_JOB_DETAILS'),
      "region": getEnvVar('REACT_APP_AWS_REGION'),
      "authorizationType": "AMAZON_COGNITO_USER_POOLS"
    }
  ],
  "aws_user_files_s3_bucket": getEnvVar('REACT_APP_S3_BUCKET'),
  "aws_user_files_s3_bucket_region": getEnvVar('REACT_APP_AWS_REGION'),
  "aws_cognito_identity_pool_id": getEnvVar('REACT_APP_IDENTITY_POOL_ID')
};

export default awsConfig;